import React from 'react';
import Text from './Text';
import { TranslatedLink } from './Text';

export default class UserCentricsOverlay extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { click_acceptGoogleMapsConsent } = this.props;

        return (
            <div className="uc-central-banner-modal-maps">
                <div className="uc-overlay">
                    <div className="uc-banner-centered">
                        <div className="uc-banner-content">
                            <div className="uc-banner-text">
                                <span className="uc-full-optin-description" tabIndex="0">
                                <Text id='usercentrics.info' />
                                </span>
                            </div>
                            <div>
                                <div className="uc-btn-accept-wrapper">
                                    <button id="selenium-test-uc-activate-button" className="uc-btn-accept" onClick={click_acceptGoogleMapsConsent}><Text id='usercentrics.button' />
                                    </button>
                                </div>
                            </div>
                            <div className="uc-banner-links">
                                <TranslatedLink href='usercentrics.impressum-url' text='usercentrics.impressum-text'className='uc-banner-impressumurl' target='_blank' />

                                <span className="uc-banner-links-separator">|</span>

                                <TranslatedLink href='usercentrics.privacy-url' text='usercentrics.privacy-text' className='uc-banner-privacyurl' target='_blank' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
